import type { ReactNode, SVGProps } from "react";

export function ArrowReturnIcon(props: SVGProps<SVGSVGElement>): ReactNode {
	return (
		<svg
			fill="none"
			height="14"
			viewBox="0 0 13 14"
			width="13"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g clipPath="url(#clip0_220_212)">
				<path
					d="M9.75016 3.5V7C9.75016 7.46413 9.57896 7.90925 9.27421 8.23744C8.96946 8.56563 8.55614 8.75 8.12516 8.75H2.7085M4.87516 11.0833L2.7085 8.75L4.87516 6.41667"
					stroke="#4D4D4D"
					strokeLinecap="round"
					strokeLinejoin="round"
					strokeWidth="1.5"
				/>
			</g>
			<defs>
				<clipPath id="clip0_220_212">
					<rect fill="white" height="14" width="13" />
				</clipPath>
			</defs>
		</svg>
	);
}
